import { render, staticRenderFns } from "./CurrentLpo__dataBlock.vue?vue&type=template&id=8b0b906c&scoped=true&"
import script from "./CurrentLpo__dataBlock.vue?vue&type=script&lang=js&"
export * from "./CurrentLpo__dataBlock.vue?vue&type=script&lang=js&"
import style0 from "./CurrentLpo__dataBlock.vue?vue&type=style&index=0&id=8b0b906c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0b906c",
  null
  
)

export default component.exports